enum HeaderStyle {
  Gradient = "gradient",
  Solid = "solid",
}

export default HeaderStyle;
